const MOBILE_BREAKPOINT = 768;
const MIN_MOBILE_SCALE = 0.65;
const DEFAULT_VIEWPORT = 'width=device-width, initial-scale=1.0';
const EXCLUDED_VIEWPORT_SCALE_ROUTES: string[] = [];

function normalizePathname(pathname: string) {
  if (!pathname) return '/';
  return pathname === '/' ? pathname : pathname.replace(/\/+$/, '');
}

function isPathnameMatch(pathname: string, routePattern: string) {
  const normalizedPathname = normalizePathname(pathname);
  const normalizedPattern = normalizePathname(routePattern);

  if (normalizedPattern.endsWith('*')) {
    const prefix = normalizePathname(normalizedPattern.slice(0, -1));
    return normalizedPathname === prefix || normalizedPathname.startsWith(`${prefix}/`);
  }

  return (
    normalizedPathname === normalizedPattern ||
    normalizedPathname.startsWith(`${normalizedPattern}/`)
  );
}

function shouldExcludeAdaptiveViewportScale(pathname: string) {
  return EXCLUDED_VIEWPORT_SCALE_ROUTES.some((routePattern) =>
    isPathnameMatch(pathname, routePattern)
  );
}

function upsertViewportMetaTag() {
  let viewportMeta = document.querySelector<HTMLMetaElement>('meta[name="viewport"]');
  if (!viewportMeta) {
    viewportMeta = document.createElement('meta');
    viewportMeta.name = 'viewport';
    document.head.appendChild(viewportMeta);
  }
  return viewportMeta;
}

function applyAdaptiveViewportScale() {
  const viewportMeta = upsertViewportMetaTag();
  const currentPathname = window.location.pathname;
  const screenWidth = window.innerWidth;
  const isMobile = screenWidth < MOBILE_BREAKPOINT;

  if (!isMobile) {
    viewportMeta.content = DEFAULT_VIEWPORT;
    return;
  }

  // Keep very small phones usable while still scaling content down.
  const scale = Math.max(MIN_MOBILE_SCALE, Math.min(screenWidth / MOBILE_BREAKPOINT, 1));
  const fixedScale = scale.toFixed(3);
  viewportMeta.content = `width=device-width, initial-scale=${fixedScale}`;
}

export function setupAdaptiveViewportScale() {
  applyAdaptiveViewportScale();
  window.addEventListener('resize', applyAdaptiveViewportScale, { passive: true });
  window.addEventListener('orientationchange', applyAdaptiveViewportScale, { passive: true });
  window.addEventListener('popstate', applyAdaptiveViewportScale, { passive: true });

  const originalPushState = window.history.pushState;
  window.history.pushState = function pushState(...args) {
    originalPushState.apply(this, args);
    applyAdaptiveViewportScale();
  };

  const originalReplaceState = window.history.replaceState;
  window.history.replaceState = function replaceState(...args) {
    originalReplaceState.apply(this, args);
    applyAdaptiveViewportScale();
  };
}
